var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3297_46401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79938 10.638L6.95312 11.0452L7.36038 8.199L14.6789 0.880498C14.8378 0.71489 15.0282 0.582661 15.2388 0.491558C15.4495 0.400456 15.6762 0.352311 15.9057 0.349945C16.1352 0.347579 16.3629 0.39104 16.5754 0.47778C16.7879 0.564521 16.981 0.692797 17.1433 0.855094C17.3056 1.01739 17.4339 1.21045 17.5206 1.42295C17.6073 1.63545 17.6508 1.86312 17.6484 2.09263C17.6461 2.32214 17.5979 2.54888 17.5068 2.75954C17.4157 2.97021 17.2835 3.16058 17.1179 3.3195L9.79938 10.638Z",
    stroke: "#181B5E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.125H1.875C1.47718 4.125 1.09564 4.28304 0.81434 4.56434C0.533035 4.84564 0.375 5.22718 0.375 5.625V16.125C0.375 16.5228 0.533035 16.9044 0.81434 17.1857C1.09564 17.467 1.47718 17.625 1.875 17.625H12.375C12.7728 17.625 13.1544 17.467 13.4357 17.1857C13.717 16.9044 13.875 16.5228 13.875 16.125V9",
    stroke: "#181B5E",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3297_46401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCard);
export default __webpack_public_path__ + "static/media/edit-card.cd1714f4f10dea66bf711c791a9e8ef6.svg";
export { ForwardRef as ReactComponent };